module.exports = __webpack_public_path__ + "static/media/Kim Pita.f6e9b8f1.png";